import { Qrcode } from '@/typings/types';
import Image from 'next/image';
import Link from 'next/link';
import Title from '@/components/qrcode/header/title';

type HeaderProps = {
  header: Qrcode['header'];
};

const Header = ({ header }: HeaderProps) => {
  const cover = header?.cover?.data?.attributes;
  const { url, placeholder, alternativeText } = cover ?? {};
  const src = `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}?resize=1500x1000`;
  return (
    <header
      className={'pt-16 pb-24 bg-black text-white flex flex-col relative items-start justify-start'}
    >
      {url && (
        <Image
          src={src}
          alt={alternativeText ?? ''}
          fill
          priority
          className={'opacity-60 object-cover z-10'}
          placeholder={placeholder ? 'blur' : 'empty'}
          blurDataURL={placeholder ?? ''}
        />
      )}
      <Link
        className={
          'lg:w-10/12 xl:w-8/12 underline font-bold underline-offset-4 3xl:text-3xl 3xl:w-7/12 relative mx-auto z-20 font-libertineRegular text-2xl'
        }
        href={'/'}
      >
        Revenir à l&apos;accueil
      </Link>
      <Title header={header} />
    </header>
  );
};

export default Header;
